module.exports = __webpack_public_path__ + "img/TIPPSPIEL_Banner_Partner.f256b06d.png";